import { BaseApiFacade } from '@emcd-shared/api-service'
import { businessErrorInterceptor } from './interceptors'
import {
  requestInterceptor,
  requestErrorInterceptor,
  responseInterceptor,
  responseErrorInterceptor,
} from '@/packages/auth-service/api'
import store from '@/app/store'
import CONFIG from '@/app/config/config'

class B2BApiClient extends BaseApiFacade {
  constructor() {
    super()
    this.client = this.create(CONFIG.B2B_ENDPOINT_URL)
    this._app = null
    this._isInitialized = false
  }

  init(app) {
    if (this._isInitialized) {
      return
    }

    this._app = app
    this._setupInterceptors()
    this._isInitialized = true
  }

  _setupInterceptors() {
    this.client.client.interceptors.request.use(
      requestInterceptor,
      requestErrorInterceptor
    )

    this.client.client.interceptors.response.use(
      responseInterceptor,
      responseErrorInterceptor(
        this.client.client,
        (res) => {
          store.dispatch('auth/authenticate', res)
        },
        this._app
      )
    )

    this.client.client.interceptors.response.use(
      null,
      businessErrorInterceptor(store)
    )
  }

  getClient() {
    return this.client
  }
}

export const b2bApiClient = new B2BApiClient()
export default b2bApiClient
